import React, { useContext, useState, useEffect } from 'react';
import { Text } from '../Text';
import DocDuplicate from 'wix-ui-icons-common/DocDuplicate';
import { LOGGER_TYPES } from '../../../LoggerFactory/loggerTypes';
import { examplesCopyCodeClick } from '../../../LoggerFactory/BiAnalyticsLogger/events';
import {
  getArticleNameFromPathname,
  getCategoryNameFromPathname,
} from '../../../LoggerFactory/BiAnalyticsLogger/events/utils';
import { LoggerContext } from '../../../appContext/LoggerProvider';
import { StoreContext } from '../../../appContext/StoreProvider';
import { useLocation } from 'react-router';
import { fromRelativeUrlToAbsoluteUrl } from '../../../../utils/locationUtils';
import { clearTimeoutIfNeeded } from '../../../../utils/timeout.utils';
import style from './CopyCode.scss';

interface CopyCodeProps {
  dataHook: string;
  code: string;
  light: boolean;
}

export const CopyCode = ({ code, light = false, dataHook }: CopyCodeProps) => {
  const location = useLocation();

  const { logger } = useContext(LoggerContext);
  const { store } = useContext(StoreContext);

  const [timeoutId, setTimeoutId] = useState(null);
  const [copiedCode, setCopiedCode] = useState(false);

  useEffect(() => {
    clearTimeoutIfNeeded(timeoutId);
    setTimeoutId(
      setTimeout(() => {
        setCopiedCode(false);
      }, 2000),
    );
    return () => {
      clearTimeoutIfNeeded(timeoutId);
    };
  }, [copiedCode]);

  return (
    <Text
      tagName="span"
      size="tiny"
      weight="thin"
      link={!light}
      light={light}
      onClick={() => {
        sendCopyCodeBiEvent();
        copyCode();
      }}
      className={style.copyCodeContainer}
      dataHook={dataHook}
    >
      <DocDuplicate size="18px" />
      <span data-hook="copy-button">
        {copiedCode ? 'Copied!' : 'Copy Code'}
      </span>
    </Text>
  );

  function copyCode() {
    const el = document.createElement('textarea');
    el.value = code;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand && document.execCommand('copy');
    document.body.removeChild(el);
    setCopiedCode(true);
  }

  function sendCopyCodeBiEvent() {
    logger.getLogger(LOGGER_TYPES.ANALYTICS_BI).log(examplesCopyCodeClick, {
      id: btoa(escape(code)),
      article_name: getArticleNameFromPathname(location.pathname, store),
      category_name: getCategoryNameFromPathname(location.pathname, store),
      article_url: fromRelativeUrlToAbsoluteUrl(
        location.pathname,
        window.location.origin,
        store,
      ),
    });
  }
};
